import { render, staticRenderFns } from "./Reader.vue?vue&type=template&id=e3d64800"
import script from "./Reader.vue?vue&type=script&lang=js"
export * from "./Reader.vue?vue&type=script&lang=js"
import style0 from "./Reader.vue?vue&type=style&index=0&id=e3d64800&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports